import React, { useState } from "react";
import * as XLSX from "xlsx";
import {
    getFirestore,
    doc,
    writeBatch,
    collection,
} from "firebase/firestore";
import Swal from "sweetalert2";
import db from "./Firebase";

const ExcelUploader = () => {
    const [excelData, setExcelData] = useState([]);
    const [uploading, setUploading] = useState(false);
    const [logs, setLogs] = useState({
        updated: [],
        notFound: [],
        skipped: [],
    });

    const handleFileUpload = async (e) => {
        const file = e.target.files[0];
        const reader = new FileReader();

        reader.onload = async (evt) => {
            const bstr = evt.target.result;
            const wb = XLSX.read(bstr, { type: "binary" });
            const wsname = wb.SheetNames[0];
            const ws = wb.Sheets[wsname];
            const data = XLSX.utils.sheet_to_json(ws);
            setExcelData(data);
            Swal.fire("File Loaded", `${data.length} rows found`, "success");
        };

        reader.readAsBinaryString(file);
    };

    const updateFirestoreData = async () => {
        if (excelData.length === 0) {
            Swal.fire("No data!", "Please upload a valid Excel file first", "error");
            return;
        }

        const batch = writeBatch(db);
        const collectionRef = collection(db, "parlour_name");
        setUploading(true);

        let updated = [];
        let notFound = [];
        let skipped = [];

        for (const row of excelData) {
            const phone = row["Phone No"]?.toString().trim();
            const state = row["State"]?.trim();
            const city = row["City"]?.trim();
            const village_town = row["Village"]?.trim();

            if (!phone || !state || !city || !village_town) {
                skipped.push({ phone, reason: "Missing required field(s)" });
                continue;
            }

            try {
                const querySnapshot = await db
                    .collection("parlour_name")
                    .where("phone", "==", phone)
                    .get();

                if (!querySnapshot.empty) {
                    querySnapshot.forEach((docRef) => {
                        const docRefPath = doc(db, "parlour_name", docRef.id);
                        batch.update(docRefPath, {
                            state,
                            city,
                            village_town,
                        });
                        updated.push(phone);
                    });
                } else {
                    notFound.push(phone);
                }
            } catch (err) {
                skipped.push({ phone, reason: err.message });
                continue;
            }
        }

        await batch.commit();
        setUploading(false);
        setLogs({ updated, notFound, skipped });

        Swal.fire(
            "Update Complete",
            `${updated.length} records updated.
${notFound.length} not found.
${skipped.length} skipped.`,
            "success"
        );

        // Console logs
        console.log("✅ Updated:", updated);
        console.log("❌ Not Found:", notFound);
        console.log("⚠️ Skipped:", skipped);
    };

    return (
        <div style={{ padding: "2rem", fontFamily: "Arial" }}>
            <h2>📤 Upload Excel to Update Parlour Data</h2>

            <input type="file" accept=".xlsx, .xls" onChange={handleFileUpload} />

            <button
                style={{ marginTop: "1rem" }}
                onClick={updateFirestoreData}
                disabled={uploading || excelData.length === 0}
            >
                {uploading ? "Updating..." : "Update Firestore"}
            </button>

            {excelData.length > 0 && (
                <p style={{ marginTop: "1rem" }}>📄 Loaded {excelData.length} rows.</p>
            )}

            <div style={{ marginTop: "2rem" }}>
                <h3>📋 Logs</h3>

                <div>
                    <strong>✅ Updated ({logs.updated.length}):</strong>
                    <ul>
                        {logs.updated.map((p, i) => (
                            <li key={`upd-${i}`}>{p}</li>
                        ))}
                    </ul>
                </div>

                <div>
                    <strong>❌ Not Found ({logs.notFound.length}):</strong>
                    <ul>
                        {logs.notFound.map((p, i) => (
                            <li key={`nf-${i}`}>{p}</li>
                        ))}
                    </ul>
                </div>

                <div>
                    <strong>⚠️ Skipped ({logs.skipped.length}):</strong>
                    <ul>
                        {logs.skipped.map((s, i) => (
                            <li key={`sk-${i}`}>
                                {s.phone || "Unknown"} - {s.reason}
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default ExcelUploader;


// import React, { useState } from "react";
// import * as XLSX from "xlsx";
// import {
//     getFirestore,
//     doc,
//     getDoc,
//     writeBatch,
//     collection,
// } from "firebase/firestore";
// import Swal from "sweetalert2";
// import db from "./Firebase"; // make sure this exports initialized Firestore instance

// const ExcelUploader = () => {
//     const [excelData, setExcelData] = useState([]);
//     const [uploading, setUploading] = useState(false);

//     // Parse Excel File
//     const handleFileUpload = async (e) => {
//         const file = e.target.files[0];
//         const reader = new FileReader();

//         reader.onload = async (evt) => {
//             const bstr = evt.target.result;
//             const wb = XLSX.read(bstr, { type: "binary" });
//             const wsname = wb.SheetNames[0];
//             const ws = wb.Sheets[wsname];
//             const data = XLSX.utils.sheet_to_json(ws);
//             setExcelData(data);
//             Swal.fire("File Loaded", `${data.length} rows found`, "success");
//         };

//         reader.readAsBinaryString(file);
//     };

//     const updateFirestoreData = async () => {
//         if (excelData.length === 0) {
//             Swal.fire("No data!", "Please upload a valid Excel file first", "error");
//             return;
//         }

//         const batch = writeBatch(db);
//         const collectionRef = collection(db, "parlour_name");
//         setUploading(true);

//         let updatedCount = 0;
//         let notFound = [];

//         for (const row of excelData) {
//             const { "Phone No": phone, State: state, City: city, Village: village_town } = row;

//             if (!phone) continue;

//             const querySnapshot = await db.collection("parlour_name")
//                 .where("phone", "==", phone.toString())
//                 .get();

//             if (!querySnapshot.empty) {
//                 querySnapshot.forEach((docRef) => {
//                     const docRefPath = doc(db, "parlour_name", docRef.id);
//                     batch.update(docRefPath, {
//                         state,
//                         city,
//                         village_town,
//                     });
//                     updatedCount++;
//                 });
//             } else {
//                 notFound.push(phone);
//             }
//         }

//         await batch.commit();
//         setUploading(false);

//         Swal.fire(
//             "Update Complete",
//             `${updatedCount} records updated.\n${notFound.length} not found.`,
//             "success"
//         );

//         if (notFound.length > 0) {
//             console.warn("Phones not found:", notFound);
//         }
//     };

//     return (
//         <div style={{ padding: "2rem" }}>
//             <h2>📤 Upload Excel to Update Parlour Data</h2>

//             <input type="file" accept=".xlsx, .xls" onChange={handleFileUpload} />

//             <button
//                 style={{ marginTop: "1rem" }}
//                 onClick={updateFirestoreData}
//                 disabled={uploading || excelData.length === 0}
//             >
//                 {uploading ? "Updating..." : "Update Firestore"}
//             </button>

//             <p>{excelData.length > 0 && `Loaded ${excelData.length} rows.`}</p>
//         </div>
//     );
// };

// export default ExcelUploader;
